import {Box, Text, Tiles} from '@primer/react-brand'
import type {Document} from '@contentful/rich-text-types'

import {Logo} from '../../../components/FlexSuiteLogos/Logo'
import {renderWithoutParagraphs} from '../../../utils'

interface PricingSectionLogosProps {
  tiles: string[]
  lead?: Document
}

export function PricingSectionLogos({tiles, lead}: PricingSectionLogosProps) {
  return (
    <Box marginBlockStart={48} data-testid="pricing-tiles">
      {lead && (
        <Box
          paddingBlockEnd={{
            narrow: 'spacious',
            regular: 64,
          }}
          paddingBlockStart="spacious"
        >
          <Text as="p" size="200" variant="muted" align="center">
            {renderWithoutParagraphs(lead)}
          </Text>
        </Box>
      )}
      <Tiles variant="gridlines" layout="compact">
        {tiles.map(tile => (
          <Tiles.Item key={tile} name={tile} data-testid={`pricing-tile-${tile}`}>
            <Logo name={tile} />
          </Tiles.Item>
        ))}
      </Tiles>
    </Box>
  )
}
